/* @flow */

export default function dateTimeFormat(dateString: Date, options?: Object): string {
  return new global.Intl.DateTimeFormat('en-us', options).format(dateString);
}
